import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { cbomApi } from "../report/services/cbom.api";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initFilter = {
    item_id: null,
    kind: null,
    type: null,
};
export const initSort = {
    property: "issue_count",
    reverse: true,
};
/** Initial state for SBOM table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
    filteredByLink: false,
};
const cbomSlice = createSlice({
    name: "cbom",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            // reset id because it is only updated via special action, not UI control
            state.filter.item_id = null;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
            state.filteredByLink = false;
        },
        itemIdFiltered: (state, action) => {
            // other filter properties are set, versus just id, for better UX
            // since there's no UI control for id
            state.filter = {
                ...state.filter,
                ...action.payload,
            };
            state.filteredByLink = true;
            state.focusedRow = null;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
        },
        sortUpdated: (state, action) => {
            state.sort = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        expandedRowSortUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].sortBy = action.payload.sort;
                state.expandedRows[action.payload.id].pagination.currentPage = 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "cbom");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addMatcher(cbomApi.endpoints.getCryptography.matchFulfilled, (state, action) => {
            if (!state.filteredByLink || action.payload.match_count !== 1)
                return;
            state.expandedRows[action.payload.crypto_assets[0].id] = {
                pagination: initPagination,
                sortBy: COMPONENT_LIST_INIT_SORT,
            };
            state.focusedRow = action.payload.crypto_assets[0].id;
        });
    },
});
export const cbomReducer = cbomSlice.reducer;
export const { filterUpdated, itemIdFiltered, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, expandedRowSortUpdated, focusedRowUpdated, } = cbomSlice.actions;
export const selectFilter = (state) => state.report.cbom.filter;
export const selectSort = (state) => state.report.cbom.sort;
export const selectPagination = (state) => state.report.cbom.pagination;
export const selectExpandedRow = (state, id) => state.report.cbom.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a; var _b; return (_b = (_a = state.report.cbom.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectExpandedRowSort = (state, id) => { var _a; var _b; return (_b = (_a = state.report.cbom.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.sortBy) !== null && _b !== void 0 ? _b : COMPONENT_LIST_INIT_SORT; };
export const selectFocusedRow = (state) => state.report.cbom.focusedRow;
export const selectFilteredByLink = (state) => state.report.cbom.filteredByLink;
export * as default from "./cbomSlice";
//# sourceMappingURL=cbomSlice.js.map